import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Header from '../Header';

import {
  getDigitalAudience,
  getDigitalAudienceRecent
} from '../../../utils/apiMiniWidget';
import DigitalAudience from '../../views/DigitalAudience/DigitalAudience';
import { Audiencias } from '../../../../assets/images/index';
import { StyledBoxInside, StyledTitleWidget, StyledWrapper } from './style';
import { SearchByDate } from '../../views/SearchByDate';

const defaultTextForNow = 'No existen datos para el día seleccionado.';

class DigitalAudiencePage extends Component {
  constructor(props) {
    super(props);
    this.state = { recent: undefined, now: undefined };
    this.dateSelected = undefined;
  }

  componentDidMount() {
    getDigitalAudience(moment().format('YYYY-MM-DD'))
      .then(digitalNowData => {
        this.setState({ now: digitalNowData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
    getDigitalAudienceRecent()
      .then(digitalResumeData => {
        this.setState({ recent: digitalResumeData });
      })
      .catch(error => {
        console.error('Error desde PressResume', error);
      });
  }

  selectDate = fromDate => () => {
    this.dateSelected = fromDate;
    getDigitalAudience(fromDate)
      .then(digitalNowData => {
        this.setState({ now: digitalNowData });
      })
      .catch(error => {
        console.error('Error desde DigitalAudience', error);
      });
  };

  clickTitle = () => {
    this.forceUpdate();
    this.componentDidMount();
  };

  render() {
    const { history } = this.props;
    const { recent, now } = this.state;

    moment.locale('es');
    return (
      <div
        className="pressResume_container"
        style={{ backgroundColor: '#FFF' }}
      >
        <Header history={history} />

        <StyledBoxInside>
          <StyledTitleWidget
            title="audiencias digitales"
            type="resumen"
            icon={Audiencias}
            small
            onClick={this.clickTitle}
          />
          <StyledWrapper>
            <SearchByDate
              day={moment().format('DD')}
              month={moment().format('MMMM')}
              weekday={moment().format('dddd')}
              onClick={this.selectDate}
            />
          </StyledWrapper>
          <StyledWrapper>
            <DigitalAudience
              key="1"
              dataList={now}
              defaultTextForNow={defaultTextForNow}
              title={`Audiencias Digitales del ${moment(
                this.dateSelected
              ).format('DD-MM-YYYY')}`}
            />
          </StyledWrapper>
          <StyledWrapper>
            {recent && recent.length > 0 && (
              <DigitalAudience
                key="2"
                dataList={recent}
                title="Los más recientes"
              />
            )}
          </StyledWrapper>
        </StyledBoxInside>
      </div>
    );
  }
}

DigitalAudiencePage.propTypes = {
  author: PropTypes.shape({
    user: PropTypes.shape({ name: PropTypes.string }),
    association: PropTypes.shape({ name: PropTypes.string })
  })
};

export default DigitalAudiencePage;
